export const setItem = (name: string, value: string): void => {
  localStorage.setItem(name, value);
};

export const getItem = (name: string): string | null => {
  return localStorage.getItem(name);
};
